import { render, staticRenderFns } from "./Flash.vue?vue&type=template&id=08d031e8"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports